import * as angular from "angular";
import { keyBy } from "lodash";
import { globs } from "../../../../../../../services/globs";
import { getRequiredIdentifiersForType } from "../../../../../getAllowedIdentifiers";
import { buildIdentifierRows } from "../identifierRows";
import template from "./entity-identifiers-viewer.html";
import "./entity-identifiers-viewer.less";

export function controller(appState, securityService) {
	const ctrl = this;
	let expectedIdentifierTypes;

	ctrl.$onChanges = onChanges;
	ctrl.hasInactiveRows = hasInactiveRows;
	ctrl.hasVisibleRows = hasVisibleRows;
	ctrl.isExpectedMissingRow = isExpectedMissingRow;
	ctrl.isRowVisible = isRowVisible;
	ctrl.getIdentifierTypeName = getIdentifierTypeName;

	ctrl.$onInit = () => {
		const agencyIdentifierTypes = appState.forms.selected.Agency.IdentifierTypes ?? [];
		const identifierActions = globs.entityTypes
			.byType(ctrl.typeConfig.Code)
			.identifiers;

		ctrl.identifierTypesByCode = keyBy(agencyIdentifierTypes, type => type.Code);
		expectedIdentifierTypes = getRequiredIdentifiersForType(
			ctrl.typeConfig.Identifiers,
			agencyIdentifierTypes
		)
			.filter(Boolean)
			.filter(type => securityService.isActionAllowed(
				identifierActions.byCode(type.Code).read
			));
		ctrl.rows = [];
		syncRows();
	};

	function onChanges(changes) {
		const identifiersChange = changes.identifiers;
		if(!identifiersChange || identifiersChange.isFirstChange()) {
			return;
		}

		syncRows(identifiersChange.currentValue);
	}

	function syncRows(identifiers = ctrl.identifiers) {
		ctrl.rows = buildIdentifierRows(identifiers, expectedIdentifierTypes);
	}

	function hasInactiveRows() {
		return ctrl.rows.some(row => !row.IsActive && !row.isExpectedMissing);
	}

	function isRowVisible(row) {
		return row.IsActive || ctrl.includeInactive || row.isExpectedMissing;
	}

	function hasVisibleRows() {
		return ctrl.rows.some(row => isRowVisible(row));
	}

	function isExpectedMissingRow(row) {
		return !!row.isExpectedMissing;
	}

	function getIdentifierTypeName(code) {
		return ctrl.identifierTypesByCode[code]?.Name ?? code;
	}
}

export default angular.module("vesl.components.entity-identifiers-viewer", [])
	.component("entityIdentifiersViewer", {
		controller,
		template,
		bindings: {
			identifiers: "<",
			typeConfig: "<",
			canShowInactiveToggle: "<",
			includeInactive: "<",
			onToggleInactive: "&"
		}
	})
	.name;
